export default __webpack_public_path__ + "static/media/S2xSOLUTION.db61a184.jpg";